module.exports = __webpack_public_path__ + "img/home.b44f51c6.svg";